/**
 * 中文文案词典（U2 §5.2 / D5 —— i18n 全量文案）
 *  - 扁平 key，与 en.ts 一一对应；新增 UI 文案请同时补 en.ts
 */
export const zh: Record<string, string> = {
  // 通用
  'app.name': '知会 ZhiHui',
  'common.cancel': '取消',
  'common.confirm': '确定',
  'common.close': '关闭',
  'common.save': '保存',
  'common.copy': '复制',
  'common.download': '下载',
  'common.refresh': '刷新',
  'common.loading': '加载中…',
  'common.empty': '暂无内容',

  // 顶栏 / 导航
  'nav.conversations': '知会 ZhiHui',
  'nav.user': '用户中心',
  'nav.invites': '邀请码管理',
  'nav.chat': '聊天',
  'nav.menu': '打开菜单',
  'ai.joined': '知会已加入',

  // AI 模式
  'ai.mode.quiet': '静默',
  'ai.mode.partner': '共创伙伴',
  'ai.mode.host': '主持',
  'ai.mode.desc.quiet': '知会仅在被 @ 时回应',
  'ai.mode.desc.partner': '知会主动给出提示与建议',
  'ai.mode.desc.host': '知会主动参与并推进讨论',
  'chat.context': '上下文 {n} 条',

  // 成果面板（ArtifactPanel）
  'artifacts.title': '结构化成果',
  'artifacts.new': '新建',
  'artifacts.empty': '还没有结构化成果。',
  'artifacts.emptyHint': '在消息上点「+」把讨论沉淀为议题 / 方案 / 决策 / 行动。',
  'artifacts.confirm': '确认',
  'artifacts.export': '导出',
  'artifacts.section.pending': '待确认',
  'artifacts.section.issue': '议题',
  'artifacts.section.solution': '方案',
  'artifacts.section.decision': '决策',
  'artifacts.section.action': '行动',
  'artifacts.panel': '成果面板',
  'artifacts.source': '来源',
  'artifacts.aiGenerate': 'AI 生成',
  'artifacts.generating': '生成中…',
  'artifacts.generated': '已生成 {n} 个成果',
  'artifacts.generateEmpty': '没有生成新的成果',
  'artifacts.generateFailed': '生成失败',
  'artifacts.generateInstruction': '你想让知会产出什么？',
  'artifacts.generatePlaceholder': '例如：把刚才讨论沉淀成决策和下一步行动',
  'artifacts.generateHint': '知会会参考项目记忆和最近聊天记录，生成的决策/行动仍需人工确认。',
  'artifactSkill.label': '内置 Skill',
  'artifactSkill.meeting': '会议沉淀',
  'artifactSkill.meetingDesc': '综合产出议题、决策和行动。',
  'artifactSkill.issue': '提炼议题',
  'artifactSkill.issueDesc': '抽出问题、阻塞和待回答问题。',
  'artifactSkill.solution': '形成方案',
  'artifactSkill.solutionDesc': '整理候选方案、利弊、风险和推荐方案。',
  'artifactSkill.decision': '沉淀决策',
  'artifactSkill.decisionDesc': '形成一条待确认决策。',
  'artifactSkill.action': '拆解行动',
  'artifactSkill.actionDesc': '拆成任务、负责人、截止时间和完成标准。',

  // 成果类型 / 状态（用于卡片与序列化回退）
  'artifact.issue': '议题',
  'artifact.solution': '方案',
  'artifact.decision': '决策',
  'artifact.action': '行动',
  'artifact.state.draft': '草稿',
  'artifact.state.pending': '待确认',
  'artifact.state.confirmed': '已确认',
  'issue.status.in_progress': '进行中',
  'issue.status.blocked': '阻塞',
  'issue.status.resolved': '已决',

  // 会话列表（ConversationListPage）
  'list.newGroup': '新建群',
  'list.newDm': '发起私聊',
  'list.aiEntry': '与知会对话',
  'list.search': '搜索会话或消息内容',
  'list.group': '群聊',
  'list.dm': '私聊',
  'list.emptyGroup': '还没有群聊，点上方新建群',
  'list.emptyDm': '还没有私聊',
  'list.searching': '搜索中…',
  'list.searchResult': '搜索结果（{n}）',
  'list.searchEmpty': '没有匹配的会话或消息',
  'list.pin': '置顶',
  'list.unpin': '取消置顶',
  'list.preview.noMessage': '暂无消息',
  'list.preview.aiJoined': '知会已加入',
  'list.preview.aiNotJoined': '未邀请知会',
  'dialog.groupName': '群名',
  'dialog.peerAccount': '对方账号',
  'dialog.peerHint': '按账号精确发起',
  'dialog.groupEmpty': '请输入群名',
  'dialog.dmEmpty': '请输入对方账号',

  // 聊天页（ChatPage）
  'chat.manageMembers': '管理成员（{n}）',
  'chat.inviteAi': '邀请知会加入本群',
  'chat.inviting': '邀请中…',
  'chat.loadOlder': '加载更早消息',
  'chat.searchPlaceholder': '会话内搜索消息',
  'chat.notExists': '会话不存在',
  'chat.backToList': '返回列表',
  'chat.aiDmHint': '与知会私聊：每条消息都会发送给知会，无需 @',
  'chat.dmHint': '私聊不触发知会 AI',
  'chat.manageTitle': '管理成员',
  'chat.currentMembers': '当前成员（{n}）',
  'chat.memberRole.owner': '群主',
  'chat.memberRole.ai': '知会 AI',
  'chat.memberRole.member': '成员',
  'chat.addMember': '添加成员（输入已注册账号）',
  'chat.add': '添加',

  // 语言切换
  'lang.label': '语言',
  'lang.zh': '中文',
  'lang.en': 'English',

  // 模板（TemplatePicker）
  'template.title': '选择项目模板',
  'template.subtitle': '模板会预置 AI 模式与结构化成果骨架',
  'template.stdProduct': '标准产品迭代',
  'template.research': '研究调研',
  'template.content': '内容创作',
  'template.start': '开始',
  'template.skip': '不使用模板',
  'template.aiMode': 'AI 模式',

  // 项目记忆（MemoryPanel）
  'memory.title': '项目记忆',
  'memory.add': '添加记忆',
  'memory.placeholder': '记录一条项目记忆…',
  'memory.save': '保存',
  'memory.edit': '编辑',
  'memory.delete': '删除',
  'memory.empty': '暂无项目记忆',
  'memory.emptyHint': '把重要决策、约束、背景记下来，知会会在对话中参考',
  'memory.source.manual': '手动',
  'memory.source.auto': '自动',
  'memory.contextHint': '已注入对话上下文（最近 {n} 条）',
  'memory.count': '记忆 {n} 条',
  'memory.updated': '记忆已更新',
  'memory.deleted': '记忆已删除',
  'memory.added': '记忆已添加',
  'memory.contentRequired': '记忆内容不能为空',
  'memory.notFound': '记忆不存在',
  'memory.autoGenerate': 'AI 提炼',
  'memory.autoGenerating': '提炼中…',
  'memory.autoGenerated': '已提炼 {n} 条项目记忆',
  'memory.autoEmpty': '没有提炼出新的项目记忆',
  'memory.autoFailed': 'AI 提炼失败',

  // 周摘要（WeeklySummaryDialog）
  'weekly.title': '周摘要',
  'weekly.generate': '生成周报',
  'weekly.generating': '生成中…',
  'weekly.empty': '本周还没有可汇总的内容',
  'weekly.history': '历史周报（{n}）',
  'weekly.aiMissing': '缺少 AI 配置，无法生成周报',
  'weekly.error': '生成失败：{msg}',

  // 分享卡片（ShareCardDialog）
  'share.title': '分享卡片',
  'share.generate': '生成卡片',
  'share.preview': '预览',
  'share.option.summary': '会话摘要',
  'share.option.artifacts': '结构化成果',
  'share.option.weekly': '本周周报',
  'share.hint': '选择要分享的内容',

  // 反馈
  'feedback.localeSwitched': '已切换语言',
};

